import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import TextArea from '../TextArea/TextArea';

class TextAreaExample extends Component {

  state = {
    label: 'This is a label',
    placeholder: 'Enter some text',
    showCharacterCount: true,
  };

  onChangeProps = e => this.setState(e.target.value);

  onChange = e => this.setState({
    value: e.target.value
  });

  repaint = e => setTimeout(() => {
    this.setState(this.state);
  }, 0);

  render() {
    return (
      <Example {...this.props}>
        <Properties defaultProps={TextArea.defaultProps} propTypes={TextArea.propTypes} propValues={this.state}
          onChange={this.onChangeProps} exclude={['logo']}/>
        <TextArea
        {...this.state}
        onChange={this.onChange}
        onBlur={this.repaint}
        onFocus={this.repaint}/>
        <SourceCode querySelector=".text-area-example .core-textarea"/>
      </Example>
    );
  }

}

TextAreaExample.tags = 'input';

export default TextAreaExample;
